/**
 * Assigned sections under the same parent grade (e.g. 2A, 2L for Grade 2).
 */
export function getAssignedSiblingGradeIds(assignedGrades, gradeId) {
	if (!gradeId) return [];
	const current = assignedGrades.find((g) => g.id === gradeId);
	if (!current) return [gradeId];
	const parent = current.parent_grade?.trim();
	if (!parent) return [gradeId];
	return assignedGrades
		.filter((g) => g.parent_grade?.trim() === parent)
		.map((g) => g.id);
}

/**
 * Grade id to store on teacher_*_progress rows.
 * Uses the route grade when the teacher is assigned to it; otherwise the first
 * assigned section in the same parent band (e.g. watch via 2C link → save as 2A).
 */
export function resolveProgressGradeId({
	routeGradeId,
	assignedGrades,
	categoryGradeId,
	courseProgressGradeId,
	routeGradeParent,
}) {
	const fallback = categoryGradeId ?? courseProgressGradeId ?? null;
	const preferred = routeGradeId ?? fallback;
	if (!preferred) return null;

	if (assignedGrades.some((g) => g.id === preferred)) {
		return preferred;
	}

	const parentKey =
		routeGradeParent?.trim() ||
		assignedGrades.find((g) => g.id === fallback)?.parent_grade?.trim();

	if (parentKey) {
		const assignedSibling = assignedGrades.find(
			(g) => g.parent_grade?.trim() === parentKey
		);
		if (assignedSibling) return assignedSibling.id;
	}

	return preferred;
}

export function categoryIdsFromCourseProgress(courseProgressData, gradeIds) {
	return new Set(
		(courseProgressData || [])
			.filter((cp) => cp.category_id && gradeIds.includes(cp.grade_id))
			.map((cp) => cp.category_id)
	);
}

/**
 * Completed lesson counts toward upload when its grade is in the parent band,
 * or grade_id is null but course progress exists for that category in the band.
 */
export function isCompletedContentEligible(
	item,
	eligibilityGradeIds,
	eligibleCategoryIds
) {
	if (!item?.category_id || !item?.content_id) return false;
	if (item.grade_id && eligibilityGradeIds.includes(item.grade_id)) return true;
	if (!item.grade_id && eligibleCategoryIds.has(item.category_id)) return true;
	return false;
}
